document.addEventListener('DOMContentLoaded', function () {
  initPackagingRadios();

  document.addEventListener('cart:updated', function () {
    setTimeout(initPackagingRadios, 100);
  });

  function initPackagingRadios() {
    const cartDrawer = document.getElementById('cart-drawer');
    if (!cartDrawer) return;

    // Wait for the shadow DOM to be fully attached
    if (!cartDrawer.shadowRoot) {
      cartDrawer.addEventListener('sl-initial-focus', function () {
        setupRadioListeners(cartDrawer);
      });
    } else {
      setupRadioListeners(cartDrawer);
    }
  }

  function setupRadioListeners(cartDrawer) {
    // Get the footer slot that contains our packaging content
    const footerSlot = cartDrawer.shadowRoot.querySelector('slot[name="footer"]');
    if (!footerSlot) return;

    // Get the assigned elements (our packaging div should be here)
    const assignedElements = footerSlot.assignedElements();

    // Find all radio inputs with class "packaging-radio"
    let radioButtons = [];
    assignedElements.forEach((element) => {
      const radios = element.querySelectorAll('.packaging-radio');
      radios.forEach((radio) => radioButtons.push(radio));
    });

    // Add event listeners to each radio button
    radioButtons.forEach((radio) => {
      radio.addEventListener('change', function () {
        const selectedValue = this.value;

        const images = document.querySelectorAll('.cart-drawer__packaging__image');
        images.forEach((img) => (img.style.display = 'none'));

        const imageToShow = document.querySelector(`.cart-drawer__packaging__image[data-option="${selectedValue}"]`);
        if (imageToShow) {
          imageToShow.style.display = 'block';
        }

        const descriptions = document.querySelectorAll('.cart-drawer__packaging__description');
        descriptions.forEach((desc) => (desc.style.display = 'none'));

        // Show only the description for the selected radio
        const parentOption = this.closest('.cart-drawer__packaging__option');
        if (parentOption) {
          const description = parentOption.querySelector('.cart-drawer__packaging__description');
          if (description) {
            description.style.display = 'block';
          }
        }
      });
    });

    // Make sure the correct image and description is showing initially
    const checkedRadio = Array.from(radioButtons).find((radio) => radio.checked);
    if (checkedRadio) {
      checkedRadio.dispatchEvent(new Event('change'));
    }
  }
});
